import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../__aeki__/components/modal'
import { checkLogin, setPreviousRoute } from '../../../__aeki__/services/auth'

export const useCheckLogin = () => {
  const history = useNavigate()

  return (callback, closePreviousModal = true) => () =>
    checkLogin(callback, () => {
      if (closePreviousModal) Modal.pop()
      Modal.push({
        type: 'Prompt',
        componentProps: {
          title: 'Alert',
          label: 'You need to sign in to contact the childcare.',
          confirmLabel: 'Sign in',
          confirm: () => {
            Modal.pop()
            setPreviousRoute()
            history('/a/signin')
          },
        },
      })
    }) as any
}
